<template>
    <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>智能营销 - 营销智能体SaaS平台</title>
    <meta name="description" content="基于AI智能体的知识产权营销SaaS平台，提供智能客服、商标查询、客户管理、案件跟进等全方位解决方案" />
    <!-- <link rel="stylesheet" href="css/styles.css"> -->
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css" />
  </head>
  <!-- 导航栏 -->
  <header class="header">
    <div class="container">
      <div class="logo" style="flex-direction: row; display: flex; align-items: center">
        <img src="../images/matuitui_logo.jpg" style="width: 28px; height: 28px" />
        <h1 style="margin-left: 10px">码推推</h1>
      </div>
      <div class="menu-toggle">
        <i class="fas fa-bars"></i>
      </div>
      <nav class="nav">
        <ul>
          <li style="align-items: center; display: flex">
            <el-dropdown @command="command" style="">
              <div class="custom-dropdown">
                <span class="el-dropdown-link">
                  智能营销名片
                </span>
              </div>

              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item :command="option" v-for="option in options" :key="option.value">{{ option.text }}</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </li>
          <li><a href="/about">关于我们</a></li>
        </ul>
      </nav>
      <div class="auth-buttons"></div>
    </div>
  </header>

  <!-- 关于我们英雄区域 -->
  <section class="hero" id="about-hero" style="background: #799DFB;  ">
    <div class="container" style="">
      <div class="hero-content" style="text-align: center; padding-right: 0;">
        <h2>关于码推推</h2>
        <p style="color: #ffffff;">用科技创新驱动营销升级，让每一张名片都成为智能营销助手</p>
      </div>
      <img src="../images/ai_about.jpg" alt="" class="placeholder-image" style="width: 600px;height: 400px;" />
    </div>
  </section>

  <!-- 公司介绍 -->
  <section class="features" style="background: white">
    <div class="container">
      <div class="section-header">
        <h2>公司简介</h2>
        <p>深圳市码推推科技有限公司</p>
      </div>
      <div style="text-align: center; max-width: 800px; margin: 0 auto">
        <p>码推推是一家专注于智能营销名片SaaS平台的科技公司，致力于为企业提供智能化的营销解决方案。我们运用人工智能技术，将传统名片升级为智能营销工具，帮助企业实现更高效的客户获取和管理。</p>
        <p>通过整合营销资讯、AI智能客服、数据监控、客户管理等功能，我们的平台让每一张名片都成为企业的24小时智能营销助手，为企业打造专业的品牌形象，建立可持续发展的私域流量池。</p>
      </div>
    </div>
  </section>

  <!-- 企业文化 -->
  <section class="advantages" style="background: #f4faff">
    <div class="container">
      <div class="section-header">
        <h2>企业文化</h2>
        <p>创新、专注、共赢</p>
      </div>
      <div class="feature-grid">
        <div class="feature-card">
          <div class="feature-icon">
            <i class="fas fa-lightbulb"></i>
          </div>
          <h3>创新驱动</h3>
          <p>持续技术创新，推动营销方式升级，为企业带来更多可能</p>
        </div>
        <div class="feature-card">
          <div class="feature-icon">
            <i class="fas fa-bullseye"></i>
          </div>
          <h3>专注品质</h3>
          <p>专注产品研发，追求卓越品质，为客户创造更大价值</p>
        </div>
        <div class="feature-card">
          <div class="feature-icon">
            <i class="fas fa-handshake"></i>
          </div>
          <h3>合作共赢</h3>
          <p>与客户建立长期合作关系，实现互利共赢的发展目标</p>
        </div>
      </div>
    </div>
  </section>

  <!-- 发展历程 -->
  <!-- <section class="features" style="background: white">
    <div class="container">
      <div class="section-header">
        <h2>发展历程</h2>
        <p>不断创新，持续进步</p>
      </div>
      <div class="advantages-container">
        <div class="advantage-item">
          <div class="advantage-number">01</div>
          <h3>2023年</h3>
          <p>公司成立，推出智能营销名片SaaS平台1.0版本</p>
        </div>
        <div class="advantage-item">
          <div class="advantage-number">02</div>
          <h3>2024年</h3>
          <p>升级AI智能客服系统，推出数据监控和客户管理功能</p>
        </div>
        <div class="advantage-item">
          <div class="advantage-number">03</div>
          <h3>2025年</h3>
          <p>拓展行业解决方案，服务更多细分领域客户</p>
        </div>
        <div class="advantage-item">
          <div class="advantage-number">04</div>
          <h3>未来</h3>
          <p>持续创新，打造国内领先的智能营销SaaS平台</p>
        </div>
      </div>
    </div>
  </section> -->

  <!-- 页脚 -->
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-logo">
          <h2>智能营销名片</h2>
          <p>智能营销名片SaaS平台</p>
        </div>
        <div class="footer-links">
          <div class="footer-links-column">
            <h3>产品</h3>
            <ul>
              <li><a href="/introduce">智能营销名片</a></li>
              <li><a href="/tmIntroduce">知识产权智能营销名片</a></li>
            </ul>
          </div>
          <div class="footer-links-column">
            <h3>公司</h3>
            <ul>
              <li><a href="/about">关于我们</a></li>
              <!-- <li><a href="index.html#contact">联系我们</a></li> -->
            </ul>
          </div>
        </div>
      </div>
      <div class="footer-bottom" style="align-items: center; display: flex; justify-content: center">
        <p>&copy; 2025 深圳市码推推科技有限公司 版权所有  <a href="http://beian.miit.gov.cn/" style="color: #adb5bd;" target="_blank">粤ICP备2024344316号-1</a></p>
      </div>
    </div>
  </footer>
</template>

<script>

export default {
  name: "App",
  components: {
    // HelloWorld
  },
  data() {
    return {
      selected: "1",
      options: [
        { text: "智能营销名片", value: "1" },
        { text: "知识产权智能营销名片", value: "2" },
      ],
      selectOption: {},
    };
  },
  methods: {
    command(e) {
    console.log("sdfdsfds", e);
      if(this.selectOption.value === e.value){
        return
      }
      
      if(e.value === "1"){
        this.$router.push({ path: '/introduce' });
      } else {
        this.$router.push({ path: '/tmIntroduce' });
      }
      this.selectOption = e;
    },
  },
};
</script>

<style>
/* 全局样式 */
:root {
    --primary-color: #4a6bff;
    --secondary-color: #6c757d;
    --accent-color: #ff6b6b;
    --light-color: #f8f9fa;
    --dark-color: #343a40;
    --text-color: #333;
    --border-radius: 8px;
    --box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    --transition: all 0.3s ease;
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
    color: var(--text-color);
    line-height: 1.6;
    overflow-x: hidden;
}

.container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

section {
    padding: 80px 0;
}

h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 15px;
}

p {
    margin-bottom: 15px;
}

a {
    text-decoration: none;
    color: var(--primary-color);
    transition: var(--transition);
}

a:hover {
    color: #3a56d4;
}

.btn {
    display: inline-block;
    padding: 12px 24px;
    border-radius: var(--border-radius);
    font-weight: 600;
    text-align: center;
    cursor: pointer;
    transition: var(--transition);
    border: none;
}

.btn-primary {
    background-color: var(--primary-color);
    color: white;
}

.btn-primary:hover {
    background-color: #3a56d4;
    color: white;
}

.btn-secondary {
    background-color: transparent;
    border: 2px solid var(--primary-color);
    color: var(--primary-color);
}

.btn-secondary:hover {
    background-color: var(--primary-color);
    color: white;
}

.section-header {
    text-align: center;
    margin-bottom: 60px;
}

.section-header h2 {
    font-size: 36px;
    margin-bottom: 15px;
    position: relative;
    display: inline-block;
}

.section-header h2::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background-color: var(--primary-color);
}

.section-header p {
    font-size: 18px;
    color: var(--secondary-color);
}

/* 占位图像样式 */
.placeholder-image {
    /* background-color: #e9ecef; */
    border-radius: var(--border-radius);
    /* width: 100%; */
    height: 100%;
    object-fit: cover;
}

/* 导航栏 */
.header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-color: white;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    padding: 15px 0;
    transition: transform 0.3s ease;
}

.header .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.logo h1 {
    font-size: 24px;
    margin: 0;
    color: var(--primary-color);
}

.nav ul {
    display: flex;
    list-style: none;
}

.nav ul li {
    margin-left: 30px;
}

.nav ul li a {
    color: var(--dark-color);
    font-weight: 500;
}

.nav ul li a:hover {
    color: var(--primary-color);
}

.menu-toggle {
    display: none;
    font-size: 24px;
    cursor: pointer;
}

.auth-buttons {
    display: flex;
    gap: 10px;
}

/* 英雄区域 */
.hero {
    padding: 160px 0 80px;
    background: linear-gradient(135deg, #f5f7ff 0%, #e8ecff 100%);
}

.hero .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.hero-content {
    flex: 1;
    padding-right: 40px;
}

.hero-content h2 {
    font-size: 48px;
    margin-bottom: 20px;
    color: var(--dark-color);
}

.hero-content p {
    font-size: 20px;
    color: var(--secondary-color);
    margin-bottom: 30px;
}

.hero-buttons {
    display: flex;
    gap: 15px;
}

.hero-image {
    flex: 1;
    height: 450px;
    width: 450px;
}

/* 功能模块 */
.features {
    background-color: white;
}

.feature-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
}

.feature-card {
    background-color: white;
    border-radius: var(--border-radius);
    padding: 30px;
    box-shadow: var(--box-shadow);
    transition: var(--transition);
    text-align: center;
}

.feature-card:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

.feature-icon {
    font-size: 40px;
    color: var(--primary-color);
    margin-bottom: 20px;
}

.feature-card h3 {
    font-size: 22px;
    margin-bottom: 15px;
}

/* 产品优势 */
.advantages {
    /* background-color: #f8f9fa; */
}

.advantages-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
}

.advantage-item {
    background-color: white;
    border-radius: var(--border-radius);
    padding: 30px;
    box-shadow: var(--box-shadow);
    position: relative;
    overflow: hidden;
}

.advantage-number {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 60px;
    font-weight: 800;
    color: rgba(74, 107, 255, 0.1);
}

.advantage-item h3 {
    font-size: 24px;
    margin-bottom: 15px;
    position: relative;
    z-index: 1;
}

/* 应用场景 */
.scenarios {
    background-color: white;
}

.scenarios-container {
    display: flex;
    flex-direction: column;
    gap: 60px;
}

.scenario-item {
    display: flex;
    align-items: center;
    gap: 40px;
}

.scenario-item.reverse {
    flex-direction: row-reverse;
}

.scenario-image {
    flex: 1;
    height: 350px;
    border-radius: var(--border-radius);
    overflow: hidden;
    box-shadow: var(--box-shadow);
}

.scenario-content {
    flex: 1;
}

.scenario-content h3 {
    font-size: 28px;
    margin-bottom: 20px;
    color: var(--dark-color);
}

.scenario-content p {
    margin-bottom: 20px;
    font-size: 16px;
    color: var(--secondary-color);
}

.scenario-content ul {
    list-style: none;
}

.scenario-content ul li {
    margin-bottom: 10px;
    padding-left: 25px;
    position: relative;
}

.scenario-content ul li:before {
    content: "\f00c";
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    position: absolute;
    left: 0;
    color: var(--primary-color);
}

/* 客户案例 */
.cases {
    background-color: #f8f9fa;
}

.testimonial-slider {
    display: flex;
    gap: 30px;
    overflow-x: auto;
    padding: 20px 0;
    scroll-snap-type: x mandatory;
}

.testimonial {
    min-width: 500px;
    scroll-snap-align: start;
    background-color: white;
    border-radius: var(--border-radius);
    box-shadow: var(--box-shadow);
    padding: 30px;
}

.testimonial-content {
    margin-bottom: 20px;
}

.testimonial-content p {
    font-size: 18px;
    font-style: italic;
    color: var(--dark-color);
}

.testimonial-author {
    display: flex;
    align-items: center;
}

.testimonial-author img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin-right: 15px;
}

.author-info h4 {
    font-size: 18px;
    margin-bottom: 5px;
}

.author-info p {
    font-size: 14px;
    color: var(--secondary-color);
    margin: 0;
}

/* 定价方案 */
.pricing {
    background-color: white;
}

.pricing-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
    margin-bottom: 50px;
}

.pricing-card {
    background-color: white;
    border-radius: var(--border-radius);
    box-shadow: var(--box-shadow);
    padding: 40px 30px;
    text-align: center;
    transition: var(--transition);
    position: relative;
    border: 1px solid #eee;
}

.pricing-card:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

.pricing-card.popular {
    border: 2px solid var(--primary-color);
    transform: scale(1.05);
    z-index: 1;
}

.pricing-card.popular:hover {
    transform: scale(1.05) translateY(-10px);
}

.popular-tag {
    position: absolute;
    top: 0;
    right: 0;
    background-color: var(--primary-color);
    color: white;
    padding: 8px 15px;
    font-size: 14px;
    font-weight: 600;
    border-radius: 0 var(--border-radius) 0 var(--border-radius);
}

.pricing-header {
    margin-bottom: 30px;
}

.pricing-header h3 {
    font-size: 24px;
    margin-bottom: 15px;
}

.price {
    font-size: 20px;
    margin-bottom: 15px;
}

.price .currency {
    font-size: 24px;
    font-weight: 600;
    vertical-align: top;
}

.price .amount {
    font-size: 48px;
    font-weight: 700;
    color: var(--primary-color);
}

.price .period {
    font-size: 16px;
    color: var(--secondary-color);
}

.pricing-features {
    margin-bottom: 30px;
}

.pricing-features ul {
    list-style: none;
    text-align: left;
}

.pricing-features ul li {
    margin-bottom: 15px;
    padding-left: 5px;
}

.pricing-features ul li i {
    margin-right: 10px;
}

.pricing-features ul li i.fa-check {
    color: #4caf50;
}

.pricing-features ul li i.fa-times {
    color: #f44336;
}

.pricing-footer {
    margin-top: auto;
}

.custom-plan {
    text-align: center;
    margin-top: 30px;
}

.custom-plan h3 {
    font-size: 24px;
    margin-bottom: 15px;
}

/* 常见问题 */
.faq {
    background-color: #f8f9fa;
}

.faq-container {
    max-width: 800px;
    margin: 0 auto;
}

.faq-item {
    background-color: white;
    border-radius: var(--border-radius);
    box-shadow: var(--box-shadow);
    margin-bottom: 20px;
    overflow: hidden;
}

.faq-question {
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
}

.faq-question h3 {
    font-size: 18px;
    margin: 0;
}

.faq-toggle {
    font-size: 16px;
    transition: var(--transition);
}

.faq-answer {
    padding: 0 20px;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease, padding 0.3s ease;
}

.faq-item.active .faq-toggle {
    transform: rotate(45deg);
}

.faq-item.active .faq-answer {
    padding: 0 20px 20px;
    max-height: 1000px;
}

/* 联系我们 */
.contact {
    background-color: #f8f9fa;
}

.contact-container {
    display: grid;
    grid-template-columns: 3fr 2fr;
    gap: 40px;
}

.contact-form {
    background-color: white;
    border-radius: var(--border-radius);
    padding: 40px;
    box-shadow: var(--box-shadow);
}

.form-group {
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
}

.form-group input,
.form-group textarea {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: var(--border-radius);
    font-size: 16px;
}

.form-group textarea {
    resize: vertical;
}

.contact-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.info-item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.info-item i {
    font-size: 24px;
    color: var(--primary-color);
    margin-right: 15px;
}

.social-media {
    display: flex;
    gap: 15px;
    margin-top: 20px;
}

.social-media a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background-color: var(--primary-color);
    color: white;
    border-radius: 50%;
    font-size: 20px;
}

.social-media a:hover {
    background-color: #3a56d4;
    transform: translateY(-3px);
}

/* 页脚 */
.footer {
    background-color: var(--dark-color);
    color: white;
    padding: 60px 0 20px;
}

.footer-content {
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
}

.footer-logo h2 {
    color: white;
    margin-bottom: 10px;
}

.footer-logo p {
    color: #adb5bd;
}

.footer-links {
    display: flex;
    gap: 60px;
}

.footer-links-column h3 {
    color: white;
    font-size: 18px;
    margin-bottom: 20px;
}

.footer-links-column ul {
    list-style: none;
}

.footer-links-column ul li {
    margin-bottom: 10px;
}

.footer-links-column ul li a {
    color: #adb5bd;
}

.footer-links-column ul li a:hover {
    color: white;
}

.footer-bottom {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.footer-bottom p {
    margin: 0;
    color: #adb5bd;
}

.footer-bottom-links a {
    color: #adb5bd;
    margin-left: 20px;
}

.footer-bottom-links a:hover {
    color: white;
}

/* 响应式设计 */
@media (max-width: 992px) {
    .hero-content h2 {
        font-size: 36px;
    }
    
    .feature-grid {
        grid-template-columns: repeat(2, 1fr);
    }
    
    .advantages-container {
        grid-template-columns: 1fr;
    }
    
    .pricing-container {
        grid-template-columns: 1fr;
        gap: 40px;
    }
    
    .pricing-card.popular {
        transform: scale(1);
    }
    
    .pricing-card.popular:hover {
        transform: translateY(-10px);
    }
    
    .scenario-item, .scenario-item.reverse {
        flex-direction: column;
    }
    
    .contact-container {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 768px) {
    .header .container {
        flex-wrap: wrap;
    }
    
    .nav {
        order: 3;
        width: 100%;
        margin-top: 20px;
        display: none;
    }
    
    .nav ul {
        flex-direction: column;
        align-items: center;
    }
    
    .nav ul li {
        margin: 10px 0;
    }
    
    .hero .container {
        flex-direction: column;
    }
    
    .hero-content {
        padding-right: 0;
        margin-bottom: 40px;
        text-align: center;
    }
    
    .hero-buttons {
        justify-content: center;
    }
    
    .feature-grid {
        grid-template-columns: 1fr;
    }
    
    .footer-content {
        flex-direction: column;
    }
    
    .footer-logo {
        margin-bottom: 30px;
        text-align: center;
    }
    
    .footer-links {
        flex-direction: column;
        gap: 30px;
    }
    
    .footer-bottom {
        flex-direction: column;
        text-align: center;
    }
    
    .footer-bottom-links {
        margin-top: 15px;
    }
    
    .footer-bottom-links a {
        margin: 0 10px;
    }
}

@media (max-width: 576px) {
    .section-header h2 {
        font-size: 28px;
    }
    
    .hero-content h2 {
        font-size: 28px;
    }
    
    .testimonial {
        min-width: 100%;
    }
    
    .menu-toggle {
        display: block;
    }
    
    .nav {
        display: none;
    }
    
    .auth-buttons {
        margin-left: auto;
    }
}

/* 动画效果 */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.fade-in {
    animation: fadeIn 0.6s ease forwards;
}

.fade-in-delay-1 {
    animation-delay: 0.2s;
}

.fade-in-delay-2 {
    animation-delay: 0.4s;
}

.fade-in-delay-3 {
    animation-delay: 0.6s;
}

</style>
